import { GetServerSideProps, NextPage } from 'next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useQueryParams } from '@/hooks/useQueryParams';
import { useResource } from '@/lib/datx-jsonapi-react';
import { queryThinEvent } from '@/queries/thin-events';
import { StringParam } from '@/utils/url-query-string';

import { IUrlQueryStringParams } from './library/[tabId]';

const EventPage: NextPage = () => {
  const router = useRouter();
  const { eventId } = useQueryParams<IUrlQueryStringParams>({
    eventId: StringParam,
  });

  const { data: event } = useResource(queryThinEvent(eventId));

  useEffect(() => {
    if (!event) {
      return;
    }

    if (event?.state === 'post_event') {
      router.replace('/events/[eventId]/library', `/events/${router.query.eventId}/library`);
    } else {
      router.replace('/events/[eventId]/reception', `/events/${router.query.eventId}/reception`);
    }
  }, [event, router]);

  return null;
};

export const getServerSideProps: GetServerSideProps = async () => {
  return {
    props: {},
  };
};

export default EventPage;
